{
  "tabs": {
    "chat": "चॅट",
    "reminders": "स्मरणिका",
    "calendar": "दिनदर्शिका",
    "settings": "सेटिंग्ज"
  },
  "common": {
    "cancel": "रद्द करा",
    "save": "जतन करा",
    "confirm": "पुष्टी करा",
    "delete": "हटवा",
    "back": "मागे",
    "close": "बंद करा",
    "edit": "संपादित करा",
    "search": "शोधा",
    "all": "सर्व",
    "loading": "लोड करत आहे...",
    "error": "काहीतरी चूक झाली",
    "notFound": "सापडले नाही",
    "tryAgain": "कृपया पुन्हा प्रयत्न करा",
    "retry": "पुन्हा प्रयत्न करा",
    "undo": "पूर्ववत करा",
    "pullToRefresh": "ताजेतवाने करण्यासाठी ओढा",
    "justNow": "आत्ताच"
  },
  "auth": {
    "welcome": "FishMemory मध्ये आपले स्वागत आहे",
    "tagline": "आपला WhatsApp स्मरणिका सहाय्यक, आता आपल्या खिशात.",
    "subtitle": "आपला WhatsApp स्मरणिका सहाय्यक, आता आपल्या खिशात.",
    "phoneLabel": "आपला WhatsApp नंबर",
    "phoneHint": "आम्ही WhatsApp द्वारे पडताळणी कोड पाठवू",
    "invalidPhone": "कृपया वैध फोन नंबर टाका",
    "continue": "सुरू ठेवा",
    "enterPhone": "आपला WhatsApp नंबर टाका",
    "phonePlaceholder": "फोन नंबर",
    "sendCode": "कोड पाठवा",
    "verifyTitle": "आपला नंबर पडताळा",
    "otpSentTo": "6-अंकी कोड {{phone}} वर WhatsApp द्वारे पाठवला गेला आहे",
    "enterFullCode": "कृपया सर्व 6 अंक टाका",
    "invalidOtp": "अवैध कोड. कृपया पुन्हा प्रयत्न करा.",
    "otpFailed": "कोड पाठवण्यात अयशस्वी. पुन्हा प्रयत्न करा.",
    "otpResent": "कोड पुन्हा पाठवला",
    "resendIn": "{{seconds}} सेकंदांत पुन्हा पाठवा",
    "resendCode": "कोड पुन्हा पाठवा",
    "enterOtp": "आपल्या WhatsApp वर पाठवलेला कोड टाका",
    "verify": "पडताळा",
    "resend": "कोड पुन्हा पाठवा",
    "wrongNumber": "चुकीचा नंबर?",
    "backToPhone": "फोनकडे परत जा",
    "editPhone": "फोन नंबर संपादित करा",
    "error": "त्रुटी",
    "setupTitle": "चला सेटअप करूया",
    "setupSubtitle": "हे नंतर सेटिंग्जमध्ये बदलू शकता",
    "namePlaceholder": "आपले नाव",
    "letsGo": "सेटअप पूर्ण करा",
    "skipForNow": "आत्तासाठी वगळा"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "संदेश टाका...",
    "inputPlaceholder": "संदेश टाका...",
    "typing": "FishMemory टाइप करत आहे...",
    "online": "ऑनलाइन",
    "connecting": "कनेक्ट करत आहे...",
    "reconnecting": "पुन्हा कनेक्ट करत आहे...",
    "offline": "ऑफलाइन",
    "empty": "संवाद सुरू करा",
    "emptyHint": "स्मरणिका तयार करा, आपले वेळापत्रक तपासा, किंवा मदत मागा.",
    "emptyAction": "नमुना स्मरणिका पाठवा",
    "actions": "चॅट क्रिया",
    "keep": "संदेश ठेवा",
    "clearTitle": "चॅट साफ करा",
    "clearConfirm": "या डिव्हाइसवरील सर्व संदेश हटवायचे का? हे परत करता येणार नाही.",
    "clear": "चॅट साफ करा",
    "optionSelected": "निवडले: {{label}}",
    "sendingSelection": "पाठवत आहे...",
    "connectionLost": "पुन्हा कनेक्ट करत आहे..."
  },
  "reminders": {
    "title": "माझ्या स्मरणिका",
    "active": "सक्रिय",
    "today": "आज",
    "thisWeek": "या आठवड्यात",
    "history": "इतिहास",
    "items": "आयटम",
    "emptyTitle": "अजून स्मरणिका नाहीत",
    "emptySubtitle": "चॅटमधून तयार करा आणि येथे दिसतील.",
    "emptyAction": "चॅट उघडा",
    "filterActive": "सक्रिय",
    "filterToday": "आज",
    "filterWeek": "या आठवड्यात",
    "filterHistory": "इतिहास",
    "emptyState": "अजून स्मरणिका नाहीत. चॅट सुरू करा!",
    "swipeDone": "पूर्ण",
    "swipeSnooze": "स्नूझ",
    "swipeDelete": "हटवा",
    "search": "स्मरणिका शोधा...",
    "upcoming": "लवकरच",
    "completed": "पूर्ण झाले",
    "overdue": "मागे",
    "tomorrow": "उद्या",
    "synced": "सिंक केले {{value}}",
    "swipeHint": "अधिक क्रियांसाठी स्मरणिका स्वाइप करा",
    "noResults": "तुमच्या शोधाशी जुळणाऱ्या स्मरणिका नाहीत",
    "noResultsHint": "वेगळा कीवर्ड वापरा किंवा शोध साफ करा",
    "deleteAllFailed": "सर्व स्मरणिका हटवण्यात अयशस्वी"
  },
  "calendar": {
    "title": "दिनदर्शिका",
    "today": "आज",
    "tomorrow": "उद्या",
    "completed": "पूर्ण",
    "noEvents": "कोणतेही नियोजित नाही",
    "noEventsSubtitle": "स्मरणिका आणि दिनदर्शिका कार्यक्रम पाहण्यासाठी तारीख निवडा.",
    "googleEvent": "Google Calendar",
    "legendActive": "सक्रिय",
    "legendRecurring": "पुनरावृत्ती",
    "legendDone": "पूर्ण",
    "legendGoogle": "Google",
    "previousMonth": "मागील महिना",
    "nextMonth": "पुढील महिना",
    "previousYear": "मागील वर्ष",
    "nextYear": "पुढील वर्ष",
    "goToToday": "आजवर जा",
    "all": "सर्व",
    "active": "सक्रिय",
    "done": "पूर्ण",
    "paused": "थांबवलेले"
  },
  "settings": {
    "title": "सेटिंग्ज",
    "profile": "प्रोफाइल",
    "name": "प्रदर्शन नाव",
    "enterName": "आपले नाव टाका",
    "language": "भाषा",
    "uiLanguage": "अॅप भाषा",
    "uiLanguageHelp": "फक्त या डिव्हाइसवर अॅप UI, दिनदर्शिका लेबल आणि लेआउट दिशा बदलते.",
    "serverLanguage": "चॅट भाषा",
    "serverLanguageHelp": "आपल्या खात्यासाठी सर्व्हर प्रतिसाद आणि स्मरणिका संदेशांसाठी वापरली जाणारी भाषा बदलते.",
    "timezone": "टाइमझोन",
    "currentTimezone": "सध्याचा टाइमझोन",
    "timezoneHelp": "सर्व स्मरणिका वेळा या टाइमझोनमध्ये दाखवल्या जातात.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "टाइमझोन जतन करा",
    "timezoneSaved": "टाइमझोन अद्यतनित",
    "detect": "ओळखा",
    "detectFailed": "टाइमझोन ओळखण्यात अयशस्वी",
    "autoDetect": "GPS द्वारे स्वयंचलित ओळख",
    "notifications": "सूचना",
    "notificationsHelp": "फॉलो-अप स्मरणिका डिलिव्हर झाल्यानंतर पुनरावृत्ती सूचना नियंत्रित करतात. डिव्हाइस-स्तर सूचना परवानग्या आपल्या फोन सेटिंग्जमध्ये व्यवस्थापित केल्या जातात.",
    "pushEnabled": "पुश सूचना",
    "autoDoneOnFire": "फायर झाल्यावर स्वयंचलित पूर्ण चिन्हांकित करा",
    "autoDoneOnFireDesc": "बंद असल्यास, स्मरणिका सक्रिय राहतात जोपर्यंत आपण त्यांना पूर्ण म्हणून चिन्हांकित करत नाही.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "कनेक्टेड",
    "googleDisconnected": "कनेक्ट नाही",
    "googleConnectedHelp": "नवीन स्मरणिका आपोआप आपल्या कॅलेंडरशी सिंक होऊ शकतात.",
    "googleDisconnectedHelp": "Google Calendar कनेक्ट करा जेणेकरून स्मरणिका आणि कार्यक्रम सुसंगत राहतील.",
    "googleConnectFailed": "Google Calendar कनेक्ट करण्यात अयशस्वी",
    "connected": "कनेक्टेड",
    "disconnected": "कनेक्ट नाही",
    "connect": "कनेक्ट करा",
    "disconnect": "डिस्कनेक्ट करा",
    "autoSync": "नवीन स्मरणिका स्वयंचलित सिंक करा",
    "autosync": "नवीन स्मरणिका स्वयंचलित सिंक करा",
    "subscription": "सदस्यता",
    "trialUsed": "ट्रायल: {{used}}/{{total}} वापरले",
    "trialStatus": "ट्रायल उपलब्ध",
    "activeStatus": "सक्रिय सदस्यता",
    "expiredStatus": "सदस्यता कालबाह्य",
    "unsubscribedStatus": "सदस्यता नाही",
    "about": "बद्दल",
    "version": "आवृत्ती",
    "logout": "लॉग आउट",
    "logoutTitle": "लॉग आउट",
    "logoutConfirm": "आपल्याला नक्कीच लॉग आउट करायचे आहे का?",
    "noName": "नाव सेट केलेले नाही",
    "serverConnection": "सर्व्हर कनेक्शन",
    "serverUrl": "सर्व्हर URL",
    "serverEdit": "संपादित करा",
    "saveReconnect": "जतन करा आणि पुन्हा कनेक्ट करा",
    "resetDefault": "मूलभूत सेटिंग्ज रीसेट करा",
    "invalidServerUrlTitle": "अवैध सर्व्हर URL",
    "invalidServerUrlMessage": "वैध http किंवा https सर्व्हर URL टाका, उदा. https://example.com",
    "uiLanguageChangeFailed": "अॅप भाषा बदलण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    "serverLanguageChangeFailed": "चॅट भाषा बदलण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    "timezoneChangeFailed": "टाइमझोन बदलण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    "autoSyncChangeFailed": "स्वयंचलित सिंक अद्यतनित करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    "nameChangeFailed": "प्रदर्शन नाव अद्यतनित करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "स्मरणिका तपशील",
    "editTime": "वेळ संपादित करा",
    "rename": "नाव बदला",
    "snooze": "स्नूझ",
    "snooze15": "15 मिनिटांसाठी स्नूझ",
    "pause": "थांबवा",
    "pauseReminder": "स्मरणिका थांबवा",
    "resume": "पुन्हा सुरू करा",
    "resumeReminder": "स्मरणिका पुन्हा सुरू करा",
    "skip": "पुढील वगळा",
    "skipOccurrence": "ही घटना वगळा",
    "syncGoogle": "Google शी सिंक करा",
    "delete": "हटवा",
    "deleteTitle": "स्मरणिका हटवा",
    "deleteConfirm": "ही स्मरणिका कायमची हटवली जाईल.",
    "deleteRecurringTitle": "पुनरावृत्ती स्मरणिका हटवा",
    "deleteRecurringMessage": "आपण ही घटना वगळू इच्छिता की संपूर्ण मालिक हटवायची?",
    "deleteThisOccurrence": "ही घटना वगळा",
    "deleteEntireSeries": "संपूर्ण मालिका हटवा",
    "done": "पूर्ण",
    "markDone": "पूर्ण म्हणून चिन्हांकित करा",
    "undo": "पुन्हा मिळवा",
    "undoPrompt": "पुन्हा सक्रिय हवे आहे का? आता पुनर्संचयित करा.",
    "recurring": "पुनरावृत्ती",
    "nextRun": "पुढील वेळ",
    "oneTime": "एकदाच",
    "pending": "प्रलंबित",
    "sent": "पाठवले",
    "paused": "थांबवलेले",
    "active": "सक्रिय",
    "snoozed": "स्नूझ केलेले",
    "localTime": "आपल्या स्थानिक वेळेत दाखवले",
    "recurrence": "पुनरावृत्ती",
    "created": "निर्मित",
    "tags": "टॅग",
    "fireCount": "फायर वेळा",
    "actions": "क्रिया",
    "none": "काही नाही",
    "snoozeFailed": "स्मरणिका स्नूझ करण्यात अयशस्वी",
    "pauseFailed": "स्मरणिका थांबवण्यात अयशस्वी",
    "resumeFailed": "स्मरणिका पुन्हा सुरू करण्यात अयशस्वी",
    "skipFailed": "स्मरणिका वगळण्यात अयशस्वी",
    "doneFailed": "स्मरणिका पूर्ण म्हणून चिन्हांकित करण्यात अयशस्वी",
    "undoFailed": "स्मरणिका स्थिती पुनर्संचयित करण्यात अयशस्वी",
    "deleteFailed": "स्मरणिका हटवण्यात अयशस्वी",
    "rescheduleTitle": "पुन्हा वेळ ठरवायचा?",
    "rescheduleMsg": "ही स्मरणिका मागे आहे. आपण पुन्हा वेळ ठरवू इच्छिता?",
    "reschedule15": "15 मिनिटांत",
    "reschedule60": "1 तासांत",
    "keepOverdue": "जसे आहे तसे ठेवा"
  },
  "onboarding": {
    "slide1Title": "FishMemory मध्ये आपले स्वागत आहे",
    "slide1Sub": "आपला वैयक्तिक स्मरणिका सहाय्यक — WhatsApp द्वारे समर्थित आणि आपल्या खिशासाठी तयार.",
    "slide2Title": "नैसर्गिकपणे फक्त चॅट करा",
    "slide2Sub": "तुमच्या विचारांप्रमाणे स्मरणिका टाका: \"मला उद्या दुपारी 3 वाजता आईला कॉल करायला सांग\" — बाकी आम्ही सांभाळतो.",
    "slide3Title": "कधीही काहीही चुकवू नका",
    "slide3Sub": "वेळेवर सूचना मिळवा, टॅगसह व्यवस्थापित करा, आणि महत्त्वाच्या गोष्टींचे लक्ष ठेवा.",
    "getStarted": "सुरू करा",
    "next": "पुढे",
    "firstReminderTitle": "आपली पहिली स्मरणिका तयार करा!",
    "firstReminderHint": "असे काही टाइप करून पहा:",
    "firstReminderExample": "मला उद्या सकाळी 9 वाजता पाणी पिण्यासाठी सांग",
    "gotIt": "समजले!",
    "notifRationaleTitle": "वेळेवर रहा",
    "notifRationaleBody": "FishMemory ला वेळेवर स्मरण देण्यासाठी सूचना आवश्यक आहेत. तुम्हाला फक्त तुम्ही तयार केलेल्या स्मरणिकांसाठी सूचना मिळतील.",
    "notifRationaleAllow": "सूचना सक्षम करा",
    "notifRationaleLater": "कदाचित नंतर",
    "swipeHint": "जलद क्रियांसाठी उजवीकडे स्वाइप करा →",
    "calendarDragHint": "विस्तारासाठी ड्रॅग करा ↕"
  }
}
